import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-historical-report',
  templateUrl: './historical-report.component.html',
  styleUrls: ['./historical-report.component.scss']
})
export class HistoricalReportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
